import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import { AnalyticsService } from "../../services/analytics.service";
import './form-item-wpbbsa-mail-form.component.scss';
var FormItemWpbbsaMailForm = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemWpbbsaMailForm, _super);
    function FormItemWpbbsaMailForm(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        return _this;
    }
    FormItemWpbbsaMailForm.prototype.init = function () {
        this.wpbbsaMailForm = this.element.querySelector('form');
        this.wpbbsaMailFormSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
        this.formLoader = this.element.querySelector(".form__loader--container");
        this.formThankyou = this.element.querySelector(".form__thankyou--container");
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
    };
    FormItemWpbbsaMailForm.prototype.bindEvents = function () {
        var _this = this;
        // Inline validation on each input/select blur event
        var inputs = Array.from(this.wpbbsaMailForm.querySelectorAll('input, select'));
        inputs.forEach(function (input) {
            input.addEventListener('blur', function (event) {
                if (input.classList.contains('form__input--date')) {
                    var _validationService_1 = _this.validationService;
                    setTimeout(function () {
                        _validationService_1.validate([input]);
                    }, 100); // Short delay for calendar events
                }
                else {
                    _this.validationService.validate([input]); // Validate single field on blur
                }
            });
        });
        this.wpbbsaMailFormSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var formFields = _this.wpbbsaMailForm.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_this.wpbbsaMailForm.querySelectorAll(".form__group--error"));
            if (valid.length == 0) {
                // loader + hide form
                var fieldsContainer = _this.wpbbsaMailForm.querySelector('.form__fields--container');
                _this.formLoader.classList.add('active');
                fieldsContainer.classList.add('hidden');
                // Check if gRecaptcha is enabled for this form
                if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                    var gToken_1 = '';
                    try {
                        // Attempt to get recaptcha token
                        grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var err_1;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                    case 1:
                                        gToken_1 = _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        // Log error
                                        console.log("Unable to retrieve gRecaptcha Token");
                                        console.log(err_1);
                                        return [3 /*break*/, 3];
                                    case 3:
                                        // Set recaptcha token
                                        this.gRecaptchaToken = gToken_1;
                                        this.actionForm();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    catch (err) {
                        // Log error
                        console.log("Unable to retrieve gRecaptcha Token");
                        console.log(err);
                        _this.actionForm();
                    }
                }
                else {
                    _this.actionForm();
                }
            }
        }); });
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute('hidden', 'true');
                _this.showMoreBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute('hidden', 'true');
                _this.showLessBtn.removeAttribute('hidden');
                _this.dataPrivacyDetailArea.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
                _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingGroupShowBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute('hidden');
                _this.dataSharingGroupHideBtn.removeAttribute('hidden');
                _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
                _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
                _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
                _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute('hidden');
                _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
                _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
                _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
            });
        }
    };
    FormItemWpbbsaMailForm.prototype.resetForm = function () {
        if (this.wpbbsaMailForm) {
            this.wpbbsaMailForm.reset();
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    FormItemWpbbsaMailForm.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return 'NO';
        }
    };
    FormItemWpbbsaMailForm.prototype.actionForm = function () {
        // additional containers
        var success = this.element.querySelector('.form__success--container');
        var error = this.element.querySelector('.form__error--container');
        var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
        var formContainerLoader = this.element.querySelector(".form__loader--container");
        // fields
        var recipient = this.wpbbsaMailForm.querySelector('input[name=recipient]');
        var email = this.wpbbsaMailForm.querySelector('input[name=email]');
        var subject = this.wpbbsaMailForm.querySelector('input[name=subject]');
        var redirect = this.wpbbsaMailForm.querySelector('input[name=redirect]');
        var product = this.wpbbsaMailForm.querySelector('input[name=product]');
        var description = this.wpbbsaMailForm.querySelector('input[name=description]');
        var name = this.wpbbsaMailForm.querySelector('input[name=first-name]');
        var surname = this.wpbbsaMailForm.querySelector('input[name=surname]');
        var idNumber = this.wpbbsaMailForm.querySelector('input[name=id-number]');
        var contactNumber = this.wpbbsaMailForm.querySelector('input[name=contact-number]');
        var emailAdress = this.wpbbsaMailForm.querySelector('input[name=email-address]');
        var province = this.wpbbsaMailForm.querySelector('select[name=province]');
        var date = this.wpbbsaMailForm.querySelector("input[name=date]");
        var time = this.wpbbsaMailForm.querySelector("select[name=time]");
        var popiaConsent = this.wpbbsaMailForm.querySelector("input[name=popia-consent]");
        var _postData = new URLSearchParams();
        _postData.set('recipient', recipient ? recipient.value : "");
        _postData.set('email', email ? email.value : "");
        _postData.set('subject', subject ? subject.value : "");
        _postData.set('redirect', redirect ? redirect.value : "");
        _postData.set('product', product ? product.value : "");
        _postData.set('description', description ? description.value : "");
        _postData.set('name', name ? name.value : "");
        _postData.set('surname', surname ? surname.value : "");
        _postData.set('idNumber', idNumber ? idNumber.value : "");
        _postData.set('contactNumber', contactNumber ? contactNumber.value : "");
        _postData.set('emailAdress', emailAdress ? emailAdress.value : "");
        _postData.set('province', province ? province.value : "");
        _postData.set('date', date ? date.value : "");
        // _postData.set('date', date ? date.value.replace(/\//g, '-') : ``);
        _postData.set('time', time ? time.value : "");
        _postData.set('dataPrivacyConsent', popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : 'NO');
        _postData.set('dataSharingWithinOurGrpMarketingConsent', this.getDataConsentValue(this.wpbbsaMailForm, 'data-sharing-group').toString());
        _postData.set('dataSharingWithThirdPartiesMarketingConsent', this.getDataConsentValue(this.wpbbsaMailForm, 'data-sharing-3rd-party').toString());
        _postData.set('dataSharingAcrossBordersWithinOurGrpMarketingConsent', this.getDataConsentValue(this.wpbbsaMailForm, 'data-sharing-boarders').toString());
        _postData.set('recaptchaToken', this.gRecaptchaToken);
        // variables
        var url = '/services/genericformv1.jsp';
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // {responseType: 'text'}
        var analyticsService = new AnalyticsService();
        // service
        this.formsService.postForm(url, _postData, config).then(function (response) {
            formContainerLoader.classList.remove('active');
            if (!response.data || String(response.data).match(/invalid/gi) || String(response.data).match(/503/gi)) {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                error.classList.add('active');
                error.classList.remove('hidden');
                success.classList.add('hidden');
                success.classList.remove('active');
            }
            else if (response.data.captchaResponse != null && response.data.captchaResponse == false) {
                analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                error.classList.add('active');
                error.classList.remove('hidden');
                success.classList.add('hidden');
                success.classList.remove('active');
            }
            else {
                analyticsService.dtmFormComplete("complete", "200", true, "", "", contactNumber.value);
                formContainerThankyou.classList.add('active');
                success.classList.add('active');
                success.classList.remove('hidden');
                error.classList.add('hidden');
                error.classList.remove('active');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            formContainerThankyou.classList.add('active');
            error.classList.add('active');
            error.classList.remove('hidden');
            success.classList.add('hidden');
            success.classList.remove('active');
        });
    };
    return FormItemWpbbsaMailForm;
}(Base));
export { FormItemWpbbsaMailForm };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-wpbbsa-mail-form/form-item-wpbbsa-mail-form.component.ts
// module id = 1103
// module chunks = 0